import { render, staticRenderFns } from "./pair.vue?vue&type=template&id=9680184e&scoped=true"
import script from "./pair.vue?vue&type=script&lang=js"
export * from "./pair.vue?vue&type=script&lang=js"
import style0 from "./pair.vue?vue&type=style&index=0&id=9680184e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9680184e",
  null
  
)

export default component.exports